// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================
   Auth Modal
   
   Design System: Uses CSS variables from colors.css
   - Flat surfaces with borders (no gradients)
   - Minimal/no corner radii
   - Compact and simple
   ====================== */

.auth-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 2000;
}

.auth-modal-card {
  width: min(320px, 100%);
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: authModalIn 0.15s ease;
}

@keyframes authModalIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 640px) {
  .auth-modal-card {
    padding: 16px;
  }

  .auth-modal-header h2 {
    font-size: 14px;
  }
}

.auth-modal-header {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.auth-modal-logo {
  width: 48px;
  height: auto;
  margin: 0 auto 8px;
}

.auth-modal-header h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.auth-modal-header p {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 13px;
  line-height: 1.45;
}

.auth-modal-google {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px 14px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  font-family: inherit;
  transition: background 0.15s ease;
}

.auth-modal-divider {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.auth-modal-divider::before,
.auth-modal-divider::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: var(--color-border-input);
}

.auth-modal-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.auth-modal-label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--color-text-secondary);
}

.auth-modal-label input {
  padding: 10px 12px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  font-family: inherit;
}

.auth-modal-email {
  padding: 10px 12px;
  border: none;
  background: var(--color-accent-base);
  color: var(--color-text-on-accent);
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
}

.auth-modal-email:disabled {
  opacity: 0.6;
  cursor: default;
}

.auth-modal-error {
  color: #c0392b;
  font-size: 12px;
}

.auth-modal-google:hover {
  background: var(--color-bg-user-bubble);
}

.auth-modal-google img {
  width: 16px;
  height: 16px;
}

.auth-modal-footer {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 11px;
  color: var(--color-text-secondary);
  line-height: 1.4;
}

.auth-modal-footer a {
  color: var(--color-text-secondary);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.auth-modal-footer a:hover {
  color: var(--color-text-primary);
}

.auth-modal-close {
  border: none;
  background: transparent;
  color: var(--color-text-primary);
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/components/AuthModal.css"],"names":[],"mappings":"AAAA;;;;;;;2BAO2B;;AAE3B;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB","sourcesContent":["/* ======================\n   Auth Modal\n   \n   Design System: Uses CSS variables from colors.css\n   - Flat surfaces with borders (no gradients)\n   - Minimal/no corner radii\n   - Compact and simple\n   ====================== */\n\n.auth-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  z-index: 2000;\n}\n\n.auth-modal-card {\n  width: min(320px, 100%);\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  animation: authModalIn 0.15s ease;\n}\n\n@keyframes authModalIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 640px) {\n  .auth-modal-card {\n    padding: 16px;\n  }\n\n  .auth-modal-header h2 {\n    font-size: 14px;\n  }\n}\n\n.auth-modal-header {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.auth-modal-logo {\n  width: 48px;\n  height: auto;\n  margin: 0 auto 8px;\n}\n\n.auth-modal-header h2 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.auth-modal-header p {\n  margin: 0;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.auth-modal-google {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 10px 14px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 13px;\n  font-family: inherit;\n  transition: background 0.15s ease;\n}\n\n.auth-modal-divider {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.auth-modal-divider::before,\n.auth-modal-divider::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: var(--color-border-input);\n}\n\n.auth-modal-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.auth-modal-label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--color-text-secondary);\n}\n\n.auth-modal-label input {\n  padding: 10px 12px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-family: inherit;\n}\n\n.auth-modal-email {\n  padding: 10px 12px;\n  border: none;\n  background: var(--color-accent-base);\n  color: var(--color-text-on-accent);\n  font-weight: 600;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.auth-modal-email:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.auth-modal-error {\n  color: #c0392b;\n  font-size: 12px;\n}\n\n.auth-modal-google:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.auth-modal-google img {\n  width: 16px;\n  height: 16px;\n}\n\n.auth-modal-footer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  line-height: 1.4;\n}\n\n.auth-modal-footer a {\n  color: var(--color-text-secondary);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.auth-modal-footer a:hover {\n  color: var(--color-text-primary);\n}\n\n.auth-modal-close {\n  border: none;\n  background: transparent;\n  color: var(--color-text-primary);\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
